/* eslint-disable @typescript-eslint/camelcase */
import { ShipmentBookingApiRepository } from "@/app/infrastructures/repositories/api/ShipmentBookingApiRepository";
import {
  CBPPickupListEntities,
  CBPPickupManifest,
  ShipmentBookingDetail,
  ShipmentBookingEntities,
  ShipmentPrefix,
  SttManualValidation,
  SttReferenceExtValidation,
  SttReferenceAdjustment,
  ValidateShipmentId
} from "@/domain/entities/ShipmentBooking";
import { injectable } from "tsyringe";
import { AddShipmentBookingRequestInterface } from "@/data/payload/contracts/ShipmentBookingRequest";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { RequestListOnProcessStt } from "@/data/payload/api/OnProcessApiRequest";
import {
  RequestListBooking,
  SttDetailRequest
} from "@/data/payload/api/BookingRequest";
import { CreateShipmentInstantBookingDirectlyPayload, RequestValidateShipmentId } from "@/data/payload/api/ShipmentBookingRequest";

@injectable()
export class ShipmentBookingPresenter {
  private repository: ShipmentBookingApiRepository;

  constructor(repository: ShipmentBookingApiRepository) {
    this.repository = repository;
  }

  public getBookingList(
    params: RequestListBooking
  ): Promise<ShipmentBookingEntities> {
    return this.repository.getBookingList(params);
  }

  public getBookingListCBP(
    params: RequestListBooking
  ): Promise<CBPPickupListEntities> {
    return this.repository.getBookingListCBP(params);
  }

  public getManifestCBP(
    params: RequestListBooking
  ): Promise<CBPPickupManifest> {
    return this.repository.getManifestCBP(params);
  }


  public getOnProcessSttList(
    params: RequestListOnProcessStt
  ): Promise<ShipmentBookingEntities> {
    return this.repository.getOnProcessSttList(params);
  }

  public getBookingDetail(
    id: number,
    isWithEligibility: boolean,
    isAuth: boolean,
    pageType: string
  ): Promise<ShipmentBookingDetail> {
    return this.repository.getBookingDetail(id, isWithEligibility, isAuth, pageType);
  }

  public getBookingDetailByStt(
    params: SttDetailRequest
  ): Promise<ShipmentBookingDetail> {
    return this.repository.getBookingDetailByStt(params);
  }

  public getSttDetail(
    params: SttDetailRequest
  ): Promise<ShipmentBookingDetail> {
    return this.repository.getSttDetail(params);
  }

  public async addShipmentBooking(
    payload: AddShipmentBookingRequestInterface
  ): Promise<ResponsePayload> {
    return this.repository.addBookingShipment(payload);
  }

  public async addShipmentBookingV2(
    payload: AddShipmentBookingRequestInterface
  ): Promise<ResponsePayload> {
    return this.repository.addBookingShipmentV2(payload);
  }

  public async addInstantBooking(
    payload: AddShipmentBookingRequestInterface
  ): Promise<ResponsePayload> {
    return this.repository.addInstantBooking(payload);
  }

  public async validateSttManual(
    clientId: number,
    sttManual: string,
    bookingType: string,
    productType: string
  ): Promise<SttManualValidation> {
    return this.repository.validateSttManual(
      clientId,
      sttManual,
      bookingType,
      productType
    );
  }

  public async validateSttReferenceExt(
    validateType: string,
    noRefExternal: string,
    shipmentId = "",
    clientCode = ""
  ): Promise<SttReferenceExtValidation> {
    return this.repository.validateSttReferenceExt(
      validateType,
      noRefExternal,
      shipmentId,
      clientCode
    );
  }

  public async getAdjustmentStt(
    sttNo: string
  ): Promise<SttReferenceAdjustment> {
    return this.repository.getAdjustmentStt(
      sttNo
    );
  }

  public async getListShipmentPrefix(): Promise<ShipmentPrefix[]> {
    return this.repository.getListShipmentPrefix();
  }

  public async validateShipmentId(
    payload: RequestValidateShipmentId
  ): Promise<boolean> {
    return this.repository.validateShipmentId(payload);
  }

  public async validateShipmentIdWithResponse(
    payload: RequestValidateShipmentId
  ): Promise<ValidateShipmentId | null> {
    return this.repository.validateShipmentIdWithResponse(payload);
  }

  public async createShipmentInstantBookingDirectly(
    payload: CreateShipmentInstantBookingDirectlyPayload
  ): Promise<ResponsePayload> {
    return this.repository.createShipmentInstantBookingDirectly(payload);
  }
}
